export default __webpack_public_path__ + "static/media/swiper3.a883e8e6.png";